import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getUsers = () => 
  fetch(
    `${API_BASE_URL}/users`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  .then(res => res.json())

export const saveUser = async(params) => {
  const res = await fetch(
    `${API_BASE_URL}/users`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editUser = async(data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/users/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)      
    }
  )
  return await res.json()
}

export const deleteUser = async(id) => {
  const res = await fetch(
    `${API_BASE_URL}/users/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  return await res.json()
}